<div class="item-description"
     [ngClass]="classState ? 'green-bg text-white': 'grey-100'">
  <p class="text-md m-b-xs">
    <i class="material-icons green-text f-s-16 pos-rlt m-r-xs item-ask"
       [ngClass]="classState ? 'text-white': ''">help_outline</i>
    <span translate="{{title}}"></span>
  </p>
  <span translate="{{description}}"></span>
</div>
